import React, { PureComponent } from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ReferenceLine, ResponsiveContainer, Label} from 'recharts';
import AnalyticsTooltip from '../AnalyticsTooltip';

const noneLabel = "none"

const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    const data = payload[0].payload

    return (
      <AnalyticsTooltip
        kicker="Month"
        title={data.sessionLabelFull}
        rows={[
          { label: "Closed Refinances", value: data.closedRefinances },
          { label: "Tier 1", value: data.tier1Refinances > 0 ? data.tier1Refinances : noneLabel },
          { label: "Tier 2", value: data.tier2Refinances > 0 ? data.tier2Refinances : noneLabel },
          { label: "Manual", value: data.manualRefinances > 0 ? data.manualRefinances : noneLabel },
          { label: "Gross Profit", value: `$${data.grossProfitNumber.toLocaleString("en-US", {maximumFractionDigits: 0, minimumFractionDigits: 0})}` },
          { label: "Gross Revenue Increase", value: `${data.grossProfitPercent.toLocaleString("en-US", {maximumFractionDigits: 0, minimumFractionDigits: 0})}%` },
        ]}
      />
    );
  }

  return null;
};

export default class MonthlyOneYearChart extends PureComponent {

  render() 
  {
    return (
      <ResponsiveContainer width="100%" height="100%" minHeight={320}>
        <BarChart
          data={this.props.monthlyStatsYear}
          layout="horizontal"
          margin={{ top: 8, right: 18, left: 18, bottom: 6 }}
        >
          <XAxis dataKey="sessionLabel" tick={{fontSize: 12, fill: "#666C78"}} tickLine={{stroke: "#BDBFC4"}} axisLine={{stroke: "#D4D6DB"}}>
            <Label angle={0} position='left' style={{ textAnchor: 'right'}} offset={-25} dy={20}>Year-Month</Label>
          </XAxis>
          <YAxis type="number" yAxisId="left" orientation="left" stroke="#5a5c68" tick={{fontSize: 12, fill: "#666C78"}} tickLine={{stroke: "#BDBFC4"}} axisLine={{stroke: "#D4D6DB"}} domain={[0, dataMax => (Math.round(((dataMax * 1.1))/1000)*1000)]} tickFormatter={tick => `$${tick.toLocaleString('en-US')}`}>
            <Label angle={270} position='right' style={{ textAnchor: 'middle' }} offset={-70}>Gross Profit</Label>
          </YAxis>
          <YAxis dataKey="closedRefinances" type="number" domain={[0, dataMax => (dataMax * 2)]} yAxisId="right" orientation="right" stroke="#5a5c68" tick={{fontSize: 12, fill: "#666C78"}} tickLine={{stroke: "#BDBFC4"}} axisLine={{stroke: "#D4D6DB"}}>
            <Label angle={90} position='right' style={{ textAnchor: 'middle' }} offset={-20}>closed refinances</Label>
          </YAxis>
          <Tooltip content={<CustomTooltip/>} cursor={{fill: `rgba(147, 149, 153, 0.12)`}} />
          <Legend wrapperStyle={{fontSize: "0.78rem", fontWeight: 700, color: "#666C78", paddingTop: "0.35rem"}} />
          <ReferenceLine y={0} stroke="#4b4b4d" yAxisId="left" />
          <Bar yAxisId="left" dataKey="grossProfitNumber" fill="#00B812" stackId="a" name="Gross Profit" />
          <Bar yAxisId="right" dataKey="tier1Refinances" fill="#E38A86" stackId="b" name="Tier 1 Closures" />
          <Bar yAxisId="right" dataKey="tier2Refinances" fill="#CAABD1" stackId="b" name="Tier 2 Closures" />
          <Bar yAxisId="right" dataKey="manualRefinances" fill="#00B81284" stackId="b" name="Manual Closures" />
        </BarChart>
      </ResponsiveContainer>
    );
  }
}
